import styled from '@emotion/styled';

export const DropPointsWrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  '@media(max-width: 768px)': {
    display: 'none',
  },
}));
